import { render, staticRenderFns } from "./IndicatorWithSubtitleH3.vue?vue&type=template&id=3bdc42e4"
import script from "./IndicatorWithSubtitleH3.vue?vue&type=script&lang=js"
export * from "./IndicatorWithSubtitleH3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports